import { render, staticRenderFns } from "./user_permission.vue?vue&type=template&id=7b5f5fa0"
import script from "./user_permission.vue?vue&type=script&lang=js"
export * from "./user_permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports